import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ObjectSelect } from '../model/models';
import { ObjectData, ObjectStatus,ObjectAfleveradres, ObjectRapportDetails } from '../model/object';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';


@Injectable({
  providedIn: 'root'
})
export class ObjectenService {

  statusList : any;
  AfleveradresList : any;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  baseURl: string = "http://localhost:3000/dev/";
  fasen: any = [
    {
        "ID": 1,
        "Fase": "Current",
        "InvoerDatum": "1999-12-14T10:37:01.917Z",
        "MutatieDatum": "1999-12-14T10:37:01.937Z"
    },
    {
        "ID": 2,
        "Fase": "Geoffreerd",
        "InvoerDatum": "1999-12-14T10:37:04.680Z",
        "MutatieDatum": "1999-12-28T12:20:42.803Z"
    },
    {
        "ID": 3,
        "Fase": "Gefactureerd",
        "InvoerDatum": "1999-12-14T10:37:10.950Z",
        "MutatieDatum": "2000-12-04T13:08:10.180Z"
    },
    {
        "ID": 4,
        "Fase": "Concept",
        "InvoerDatum": "2000-01-05T12:16:06.063Z",
        "MutatieDatum": "2000-01-05T12:16:06.073Z"
    }
];


  constructor(private http: HttpClient,
      private common: CommonService) {
      this.baseURl = environment.url;
   }



  getFasen(): Observable<any> {
    const me = this;
    if (this.fasen != null ) {
        return new Observable<any>( (observer) => {
            observer.next(me.fasen);
            observer.complete();
        } );
    }
    return new Observable<any>( (observer) => {
        this.http.get(this.baseURl +  "objecten/fasen").pipe(
            tap(_ => this.log('fetched relatielist')),
            tap(e => { this.common.checkAndReportErrors(e)}),
            catchError(this.handleError<any>('getList', []))
            ).subscribe(data => {
              me.fasen = data;
              observer.next(me.fasen);
              observer.complete();
          });
        });
}


  getObjecten(select: ObjectSelect):  Observable<any> {

    const params = new HttpParams()
    .set('relatieid', '' + select.relatieid)
    .set('faseid', '' + select.faseid)
    .set('cpid','' + select.cpid)
    .set('objectnr','' + select.objectNr)
    .set('omschrijving','' + select.omschrijving);


    return this.http.get(this.baseURl +  "objecten",{params}).pipe(
      tap(_ => this.log('fetched contactpersonen')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getContactpersonen', []))
    );
  }


  getObject(id : number) : Observable<any> {
    return this.http.get(this.baseURl +  "objecten/" + id).pipe(
      tap(_ => this.log('fetched relatieobject')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getRelatie', []))
    );
  }

  deleteObject(id : number) : Observable<any> {
    return this.http.delete(this.baseURl +  "objecten/" + id).pipe(
      tap(_ => this.log('fetched relatieobject')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getRelatie', []))
    );
  }

  saveObject(id: Number, object: ObjectData) {
    return this.http.put(this.baseURl +  "objecten/" + id ,object, this.httpOptions).pipe(
      tap(_ => this.log('object saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveObject', []))
    );
  }

  postObject(data: ObjectSelect) : Observable<any> {
    return this.http.post(this.baseURl +  "objecten" ,data, this.httpOptions).pipe(
      tap(_ => this.log('object added')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('postObject', []))
    );
  }

  postCopyObject(objectid: number) : Observable<any>{
    return this.http.post(this.baseURl +  "objecten/copy/" + objectid ,{}, this.httpOptions).pipe(
      tap(_ => this.log('object added')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('postCopyObject', []))
    );
  }


  postMaakFactuur(objectid: number,factuurnummer: number) {
    return this.http.post(this.baseURl +  "objecten/maakfactuur/" + objectid ,{factuurnummer:factuurnummer}, this.httpOptions).pipe(
      tap(_ => this.log('object added')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('postMaakFactuur', []))
    );
  }


  postMaakOfferte(objectid: number,offertenummer : number) {
    return this.http.post(this.baseURl +  "objecten/maakofferte/" + objectid ,{offertenummer:offertenummer}, this.httpOptions).pipe(
      tap(_ => this.log('object added')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('postMaakOfferte', []))
    );
  }


  getMedewerkers() : Observable<any> {
    return this.http.get(this.baseURl +  "medewerkers").pipe(
      tap(_ => this.log('fetched getMedewerkers')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getMedewerkers', []))
    );
  }

  /** Status */

  getObjectStatusList(objectid: number) {
    return this.http.get(this.baseURl +  "objecten/" + objectid + "/status").pipe(
      tap(_ => this.log('getObjectStatusList added')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getObjectStatusList', []))
    );
  }

  deleteObjectStatus(id: number) {
    return this.http.delete(this.baseURl +  "objecten/status/" + id ,this.httpOptions).pipe(
      tap(_ => this.log('object saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveObject', []))
    );
  }

  postObjectStatus(data: ObjectStatus) {
    return this.http.post(this.baseURl +  "objecten/" + data.ObjectID + "/status" ,data, this.httpOptions).pipe(
      tap(_ => this.log('ObjectStatus added')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('postObjectStatus', []))
    );
  }

  putObjectStatus(data: ObjectStatus) {
    let copiedData = JSON.parse(JSON.stringify(data));
    copiedData.DatumHeen = this.common.formatDate(data.DatumHeen);
    copiedData.DatumTerug = this.common.formatDate(data.DatumTerug);
    return this.http.put(this.baseURl +  "objecten/" + data.ObjectID + "/status" ,copiedData, this.httpOptions).pipe(
      tap(_ => this.log('ObjectStatus added')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('postObjectStatus', []))
    );
  }

  getObjectStatusExportList(objectid: number)  {
    return this.http.get(this.baseURl +  "objecten/" + objectid + "/statusExport").pipe(
      tap(_ => this.log('getObjectStatusExportList added')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getObjectStatusList', []))
    );
  }

  // getStatusList() {
  //   return this.http.get(this.baseURl +  "status").pipe(
  //     tap(_ => this.log('getStatusList added')),
  //     catchError(this.handleError<any>('getStatusList', []))
  //   );
  // }

  getStatusList(): Observable<any> {
    const me = this;
    if (this.statusList != null ) {
        return new Observable<any>( (observer) => {
            observer.next(me.statusList);
            observer.complete();
        } );
    }
    return new Observable<any>( (observer) => {
        this.http.get(this.baseURl +  "status").pipe(
            tap(_ => this.log('fetched statusList')),
            tap(e => { this.common.checkAndReportErrors(e)}),
            catchError(this.handleError<any>('getStatusList', []))
            ).subscribe(data => {
              me.statusList = data;
              observer.next(me.statusList);
              observer.complete();
          });
        });
  }

/** Afleveradres */



getObjectAfleveradresList(objectid: number) {
  return this.http.get(this.baseURl +  "objecten/" + objectid + "/afleveradres").pipe(
    tap(_ => this.log('getObjectAfleveradresList added')),
    tap(e => { this.common.checkAndReportErrors(e)}),
    catchError(this.handleError<any>('getObjectAfleveradresList', []))
  );
}

deleteObjectAfleveradres(id: number) {
  return this.http.delete(this.baseURl +  "objecten/afleveradres/" + id ,this.httpOptions).pipe(
    tap(_ => this.log('object saved')),
    tap(e => { this.common.checkAndReportErrors(e)}),
    catchError(this.handleError<any>('saveObject', []))
  );
}

postObjectAfleveradres(data: ObjectAfleveradres) {
  return this.http.post(this.baseURl +  "objecten/" + data.ObjectID + "/afleveradres" ,data, this.httpOptions).pipe(
    tap(_ => this.log('ObjectAfleveradres added')),
    tap(e => { this.common.checkAndReportErrors(e)}),
    catchError(this.handleError<any>('postObjectAfleveradres', []))
  );
}


getObjectRelatieStatusList(KlantAfkorting: string, start : Date, end : Date):Observable<any> {
  return this.http.get(this.baseURl +  "objecten/statusrapport?KlantAfkorting="  + KlantAfkorting + 
    "&start=" +start.toISOString().substring(0,10) + 
    "&einde=" + end.toISOString().substring(0,10)).pipe(
    tap(_ => this.log('getObjectRelatieStatusList')),
    catchError(this.handleError<any>('getObjectRelatieStatusList', []))
  );
}
getObjectLevernacierStatusList(KlantAfkorting: string, ObjectNr : string):Observable<any> {
  return this.http.get(this.baseURl +  "objecten/statusrapportLeverancier?KlantAfkorting="  + KlantAfkorting + 
    "&objectnr=" +ObjectNr).pipe(
    tap(_ => this.log('getObjectRelatieStatusList')),
    catchError(this.handleError<any>('getObjectRelatieStatusList', []))
  );
}



getStatusRapportObject(id: number):Observable<any> {
  return this.http.get(this.baseURl +  "objecten/statusrapportobject?id="  + id ).pipe(
    tap(_ => this.log('getStatusRapportObject')),
    catchError(this.handleError<any>('getStatusRapportObject', []))
  );
}
getStatusRapportObjectDetails(id: number):Observable<ObjectRapportDetails> {
  return this.http.get<ObjectRapportDetails>(this.baseURl +  "objecten/statusrapportobjectdetails?id="  + id ).pipe(
    tap(_ => this.log('getStatusRapportObject')),
    catchError(this.handleError<any>('getStatusRapportObject', []))
  );
}

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


  private log(message: string) {
    console.log(`ObjectenService: ${message}`);
  }



  getAfleverbon(bonid: number, adresid : number)  : Observable<any> {
    return this.http.get(/*this.baseURl*/ "https://i2szmfzy82.execute-api.eu-central-1.amazonaws.com/dev/" +  "rapport/afleverbon/nl/" + bonid + "/" +adresid).pipe(
      tap(_ => this.log('getAfleverbon')),
      catchError(this.handleError<any>('getAfleverbon', []))
    );
  }



}
